import(/* webpackMode: "eager" */ "/var/www/apps/behes.dev/src/app/privacy-policy/policy.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apps/behes.dev/src/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apps/behes.dev/src/components/Header.jsx");
